<template>
    <div class="publishC2c">
        <!-- 绑定支付方式 -->
        <div class="topicWrap" @click="$router.push({path:'/payType'})">
            发布前至少<span>绑定一种支付方式</span>
        </div>
        <!-- 表单区域 -->
        <div class="formWrap">
            <!-- 可用余额 --->
            <div class="myBalance">
                <div>
                    <span>可用USDT：</span>
                    <span class="num">{{publishData.num || 0}}</span>
                </div>
                <div>
                    <span>总USDT：</span>
                    <span class="num">{{publishData.total || 0 }}</span>
                </div>
            </div>
            <!-- 选项 -->
            <ul class="formBox">
                <!-- 类型 -->
                <li>
                    <span class="formTitle">类型：</span>
                    <div class="typeChoose">
                        <span :class="typeIndex === 1 ? 'active' : ''" @click="typeIndex=1">购买</span>
                        <span :class="typeIndex === 2 ? 'activeA' : ''" @click="typeIndex=2">出售</span>
                    </div>
                </li>
                <li>
                    <span class="formTitle">价格：</span>
                    <div class="numInput">
                        <input type="text" placeholder="请输入价格" v-model="price">
                        <div class="typeNum"><span></span>CNY</div>
                    </div>
                </li>
                <li>
                    <span class="formTitle">数量：</span>
                    <div class="numInput">
                        <input type="text" placeholder="请输入数量" v-model="num">
                        <div class="typeNum"><span></span>USDT</div>
                    </div>
                </li>
                <li>
                    <span class="formTitle">交易类型：</span>
                    <div class="imgWrap">
                        <img :src="publishData.weixin > 0 ? wx_active : wx" alt="">
                        <img :src="publishData.alipay > 0 ? ali_active : ali" alt="">
                        <img :src="publishData.bank > 0 ? yl_active : yl" alt="">
                    </div>
                </li>
                <li>
                    <span class="formTitle">交易密码：</span>
                    <div class="numInput">
                        <input type="password" placeholder="请输入交易密码" v-model="paypassword">
                    </div>
                </li>
                <li style="margin-bottom: 0;">
                    <button class="submit" @click="submit">发布订单</button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    // 微信图片
    import wx from "@/assets/img/c2c/wx@3x.png"
    import wx_active from "@/assets/img/c2c/wx_active@3x.png"
    // 支付宝图片
    import ali from "@/assets/img/c2c/ali@3x.png"
    import ali_active from "@/assets/img/c2c/ali_active@3x.png"
    // 银联图片
    import yl from "@/assets/img/c2c/yl@3x.png"
    import yl_active from "@/assets/img/c2c/yl_active@3x.png"

    export default {
        props: {
            publishData: {
                default: {}
            }
        },
        name: "publish-c2c",
        data() {
            return {
                wx,
                wx_active,
                ali,
                ali_active,
                yl,
                yl_active,
                typeIndex: 1,
                price: "",
                num: "",
                paypassword: "",
            }
        },
        watch: {
            publishData() {
                console.log("watch", this.publishData);
            },
        },
        methods: {
            submit() {
                if (this.publishData.weixin < 0 &&
                    this.publishData.alipay < 0 &&
                    this.publishData.bank < 0) {
                    this.$toast("请先绑定支付方式");
                    return
                }
                let obj = {
                    type: this.typeIndex,
                    price: this.price,
                    num: this.num,
                    paypassword: this.paypassword,
                    coin: "usdt",
                };
                this.ajax.post('appapi/c2c/releaseC2cSet', obj).then((res) => {
                    if (res.data.code === 1) {
                        console.log(res.data);
                        this.$toast(res.data.msg);
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .publishC2c {
        margin-top: 27px;

        .topicWrap {
            width: 100%;
            height: 107px;
            line-height: 107px;
            padding-left: 119px;
            margin-bottom: 36px;
            background: url("../../../assets/img/c2c/publishBg.png") no-repeat center/cover;
            font-size: 24px;
            font-weight: 500;
            color: #999999;

            span {
                color: #32C3FF;
            }
        }

        .formWrap {
            margin: 0 30px;
            padding: 44px 54px 34px 48px;
            background: #fff;
            box-shadow: 0 10px 29px 0 rgba(226, 226, 226, 0.5);
            border-radius: 20px;

            .myBalance {
                display: flex;
                margin-bottom: 34px;

                div {
                    margin-right: 196px;

                    &:last-child {
                        margin-right: 0;
                    }

                    span {
                        display: block;
                        font-size: 28px;
                        font-weight: bold;
                        color: #333333;
                        line-height: 20px;
                    }

                    .num {
                        margin-top: 37px;
                        font-size: 36px;
                        color: #16CF7A;
                    }
                }
            }

            .formBox {
                li {
                    display: flex;
                    align-items: center;
                    height: 65px;
                    margin-bottom: 30px;

                    .formTitle {
                        display: inline-block;
                        min-width: 140px;
                        margin-right: 20px;
                        font-size: 28px;
                        font-weight: bold;
                        color: #333333;
                    }

                    .typeChoose {
                        font-size: 28px;
                        font-weight: bold;
                        color: #fff;

                        span {
                            display: inline-block;
                            width: 120px;
                            height: 61px;
                            line-height: 61px;
                            text-align: center;
                            background: #f9f9f9;
                            color: #333333;
                        }

                        .active {
                            background: #1FC26D;
                            color: #ffffff;
                        }

                        .activeA {
                            background: #FF4D30;
                            color: #ffffff;
                        }
                    }

                    .numInput {
                        position: relative;
                        width: 439px;

                        input {
                            width: 100%;
                            height: 65px;
                            padding-left: 27px;
                            background: rgba(248, 248, 248, 1);
                            border-radius: 10px;
                        }

                        .typeNum {
                            display: flex;
                            align-items: center;
                            position: absolute;
                            top: 50%;
                            transform: translateY(-50%);
                            right: 21px;
                            font-size: 28px;
                            font-weight: bold;
                            color: #7B8292;

                            span {
                                display: inline-block;
                                width: 1px;
                                height: 28px;
                                background: #E0E0E0;
                                margin-right: 27px;
                            }
                        }
                    }

                    .imgWrap {
                        display: flex;
                        align-items: center;

                        img {
                            &:nth-child(1) {
                                width: 41px;
                                margin-right: 24px;
                            }

                            &:nth-child(2) {
                                width: 40px;
                                margin-right: 33px;
                            }

                            &:nth-child(3) {
                                width: 63px;
                            }
                        }
                    }

                    .submit {
                        width: 100%;
                        height: 86px;
                        border-radius: 10px;
                        font-size: 30px;
                        font-weight: bold;
                        color: #fff;
                        background: #1FC26D;
                    }
                }
            }
        }
    }
</style>
